/* src/module/rich-text-editor/component.scss */
:host {
  display: block;
}
/*# sourceMappingURL=component-FWHQ5K7B.css.map */
